module.exports = __webpack_public_path__ + "img/times.779494e9.svg";